import { render, staticRenderFns } from "./FeatureDuration.vue?vue&type=template&id=363d9840&scoped=true"
import script from "./FeatureDuration.vue?vue&type=script&lang=js"
export * from "./FeatureDuration.vue?vue&type=script&lang=js"
import style0 from "./FeatureDuration.vue?vue&type=style&index=0&id=363d9840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363d9840",
  null
  
)

export default component.exports